<template>
  <div class="section">
    <div class="container">
      <h1 class="page-title mb-8">ตะกร้าสินค้า</h1>

      <!-- Loading -->
      <div v-if="cartStore.loading && cartStore.items.length === 0" class="text-center" style="padding: 3rem 0;">
        <div class="loading-spinner" style="margin: 0 auto;"></div>
      </div>

      <!-- Empty Cart -->
      <div v-else-if="cartStore.items.length === 0" class="empty-state">
        <svg class="empty-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z"/>
        </svg>
        <h3 class="empty-title">ตะกร้าสินค้าว่างเปล่า</h3>
        <p class="empty-desc">ยังไม่มีสินค้าในตะกร้า เริ่มช้อปปิ้งเลย!</p>
        <router-link to="/products" class="btn btn-primary btn-lg">
          เริ่มช้อปปิ้ง
        </router-link>
      </div>

      <!-- Cart Content -->
      <div v-else class="cart-layout">
        <!-- Cart Items -->
        <div class="cart-items">
          <div class="card">
            <div class="card-body">
              <CartItem 
                v-for="item in cartStore.items" 
                :key="item.id" 
                :item="item" 
                :loading="cartStore.loading"
                @update-quantity="updateQuantity"
                @remove-item="removeItem"
              />
            </div>
          </div>
        </div>

        <!-- Order Summary -->
        <div class="cart-summary">
          <CartSummary 
            :subtotal="cartStore.subtotal"
            :shipping-fee="cartStore.shippingFee"
            :total="cartStore.totalAmount"
            :disabled="cartStore.loading"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { onMounted } from 'vue';
import { useCartStore } from '../stores/cart';
import CartItem from '../components/CartItem.vue';
import CartSummary from '../components/CartSummary.vue';
import { useNotification } from '../composables/useNotification';

const cartStore = useCartStore();
const { showSuccess, showError, confirmDelete } = useNotification();

onMounted(() => {
  cartStore.fetchCart();
});

const updateQuantity = async (itemId, quantity) => {
  try {
    await cartStore.updateQuantity(itemId, quantity);
  } catch (error) {
    showError('ไม่สามารถอัปเดตจำนวนสินค้าได้');
  }
};

const removeItem = async (itemId) => {
  const confirmed = await confirmDelete('สินค้านี้');
  if (confirmed) {
    try {
      await cartStore.removeItem(itemId);
      showSuccess('ลบสินค้าเรียบร้อยแล้ว');
    } catch (error) {
      showError('ลบสินค้าล้มเหลว');
    }
  }
};
</script>

<style scoped>
.page-title {
  font-size: 1.75rem;
  font-weight: 700;
  color: var(--color-text);
}

.mb-8 {
  margin-bottom: 2rem;
}

.empty-state {
  text-align: center;
  padding: 4rem 1rem;
  background: var(--color-surface);
  border-radius: 0.75rem;
}

.empty-icon {
  width: 4rem;
  height: 4rem;
  margin: 0 auto 1rem;
  color: var(--color-text-muted);
}

.empty-title {
  font-size: 1.25rem;
  font-weight: 600;
  color: var(--color-text);
  margin-bottom: 0.5rem;
}

.empty-desc {
  color: var(--color-text-light);
  margin-bottom: 1.5rem;
}

.cart-layout {
  display: grid;
  grid-template-columns: 1fr;
  gap: 2rem;
}

@media (min-width: 1024px) {
  .cart-layout {
    grid-template-columns: 2fr 1fr;
  }
}
</style>
